/**
 *
 * @param text      String to be measured.
 * @param minWidth  Minimum width to return. Defaults to 68 (px).
 * @param padding   Extra horizontal padding (px) to add to the measured width.
 *                  Defaults to 20 (px) – useful when the returned width will be
 *                  applied directly to an input element so the cursor has some
 *                  space.
 */

export const measureTextWidth = (
  text: string,
  {
    minWidth = 68,
    padding = 20,
  }: { minWidth?: number; padding?: number } = {},
): number => {
  if (typeof document === 'undefined') {
    return minWidth;
  }

  const span = document.createElement('span');
  span.style.visibility = 'hidden';
  span.style.position = 'fixed';
  span.style.fontSize = '16px';
  span.style.fontFamily = 'inherit';
  span.style.fontWeight = '400';
  span.style.whiteSpace = 'pre';
  span.innerText = text || '$2000';

  document.body.appendChild(span);
  const width = span.offsetWidth + padding;
  document.body.removeChild(span);

  return Math.max(width, minWidth);
};
